export class Attend {
    public id: number;
    public stime: string;
    public etime: string;
    public sid: number;
    public school: number;
}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Models/attend.ts